import { Box } from '@mui/material';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import orbyLogo from '../../static/icons/orby-drawer-logo.svg';
import orbyIcon from '../../static/icons/orbyIcon.svg';
import { DRAWER_TABS } from './tabs';

import DrawerFooter from './DrawerFooter';
import DrawerTab from './DrawerTab';

interface Props {
  collapse: boolean;
  setCollapse: (val: boolean) => void;
}

const WebDrawerWrapper: FC<Props> = ({ collapse, setCollapse }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedPath = useMemo(() => {
    const arr = location.pathname.split('/');
    return arr[arr.length - 1];
  }, [location.pathname]);

  const handleDrawerItemClick = useCallback(
    (path: string) => navigate(path),
    [],
  );

  const renderHeader = useMemo(() => {
    return (
      <Box
        component={'img'}
        width={collapse ? '40px' : '70px'}
        sx={{
          marginLeft: collapse ? '12px' : '20px',
          marginTop: '40px',
          marginBottom: '37px',
        }}
        src={collapse ? orbyIcon : orbyLogo}
        alt='Orby Logo'
      />
    );
  }, [collapse]);

  return (
    <Box
      bgcolor={'#031026'}
      width={collapse ? '64px' : '240px'}
      height='100vh'
      position={'fixed'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      zIndex={40}
    >
      <>
        {renderHeader}
        <Box
          display={'flex'}
          role={'tablist'}
          flexDirection={'column'}
          alignItems={'center'}
          height={'calc(100% - 189px)'}
          sx={collapse ? { paddingX: '8px' } : { paddingX: '16px' }}
        >
          {DRAWER_TABS.map((tab, index) => {
            return (
              <DrawerTab
                key={index}
                data={tab}
                index={index}
                collapse={collapse}
                isSelected={tab.route === selectedPath}
                onClick={handleDrawerItemClick}
              />
            );
          })}
        </Box>
      </>
      <DrawerFooter collapse={collapse} setCollapse={setCollapse} />
    </Box>
  );
};

export default memo(WebDrawerWrapper);
